/* eslint class-methods-use-this: 0 */
import { DirectoryNameConsts, DirectoryTypeConsts } from 'client/util/Constants';
import CollectionApi from 'client/api/v2/CollectionApi';
import O365ImportApiSearchBuilder from 'client/util/O365ImportApiSearchBuilder';
import axios from 'axios';

class O365ImportApi extends CollectionApi {
  constructor(o365Id = '') {
    super(`/api/v2/office365s/${o365Id}/import/users`, {
      limit: 50,
      sort: '',
    }, 100, false, true);
  }

  fetch(skip, limit, sort, searchTerm, cancelToken, filters, pageToken, skipToken) {
    const params = {
      ...O365ImportApiSearchBuilder.getO365ApiSearchParams(searchTerm),
      skipToken,
      top: limit,
    };

    const requestConfig = {
      cancelToken,
    };
    if (searchTerm) {
      requestConfig.headers = O365ImportApiSearchBuilder.getO365ApiHeaders();
    }

    return new Promise((resolve, reject) => {
      this.initialize()
        .then(() => axios.get(`${this.baseUrl}?${this.param(params)}`, requestConfig))
        .then((resp) => {
          const { data } = resp;
          resolve({
            results: data.users,
            totalCount: data.users.length,
            skipToken: data.skipToken,
          });
        })
        .catch((error) => {
          const mesg = `Unable to retrieve ${DirectoryNameConsts[DirectoryTypeConsts.office365]} users.`;
          this.handleFetchError(reject, mesg, error);
        });
    });
  }

  setO365Id(o365Id) {
    this.baseUrl = `/api/v2/office365s/${o365Id || ''}/import/users`;
  }

  /**
   * By default, filter parameter is built based on
   * filters values (filter: 'isNew:eq:true')
   * For O365 API in BE, filter parameter is expected
   * with a specific string format defined by Microsoft Graph REST API
   * Filter is left as empty while it's actually needed and this way
   * unexpected values are avoided
   * @todo Define correct filter parameter functionality when it's needed
   * @see https://docs.microsoft.com/en-us/graph/api/user-list?view=graph-rest-1.0&tabs=http#example-4-use-filter-and-top-to-get-one-user-with-a-display-name-that-starts-with-a-including-a-count-of-returned-objects
   */
  setFilterTerm() {
    return '';
  }
}

export default new O365ImportApi();
